var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewCertIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_141_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6666 5.3335V3.46683C10.6666 2.72009 10.6666 2.34672 10.5213 2.06151C10.3934 1.81063 10.1895 1.60665 9.93857 1.47882C9.65336 1.3335 9.27999 1.3335 8.53325 1.3335H3.46659C2.71985 1.3335 2.34648 1.3335 2.06126 1.47882C1.81038 1.60665 1.60641 1.81063 1.47858 2.06151C1.33325 2.34672 1.33325 2.72009 1.33325 3.46683V8.5335C1.33325 9.28023 1.33325 9.6536 1.47858 9.93882C1.60641 10.1897 1.81038 10.3937 2.06126 10.5215C2.34648 10.6668 2.71985 10.6668 3.46659 10.6668H5.33325M7.99992 10.0002L9.33325 11.3335L12.3333 8.3335M7.46659 14.6668H12.5333C13.28 14.6668 13.6534 14.6668 13.9386 14.5215C14.1895 14.3937 14.3934 14.1897 14.5213 13.9388C14.6666 13.6536 14.6666 13.2802 14.6666 12.5335V7.46683C14.6666 6.72009 14.6666 6.34672 14.5213 6.06151C14.3934 5.81063 14.1895 5.60665 13.9386 5.47882C13.6534 5.3335 13.28 5.3335 12.5333 5.3335H7.46659C6.71985 5.3335 6.34648 5.3335 6.06126 5.47882C5.81038 5.60665 5.60641 5.81063 5.47858 6.06151C5.33325 6.34672 5.33325 6.72009 5.33325 7.46683V12.5335C5.33325 13.2802 5.33325 13.6536 5.47858 13.9388C5.60641 14.1897 5.81038 14.3937 6.06126 14.5215C6.34648 14.6668 6.71985 14.6668 7.46659 14.6668Z",
    stroke: "#6366F1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_141_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewCertIcon);
export default __webpack_public_path__ + "static/media/review-cert-icon.494733a2c598fe0ffbbb3d781b25ad69.svg";
export { ForwardRef as ReactComponent };